import { getUpgradeCurrentReplaceValueById } from "@/game/utils/upgrades";
import useSiegeSystemRepository from "@/hooks/useSiegeSystemRepository";
import { type TileIndex, type TileNeighbour } from "@/types/tile";
import {
	FrameName,
	tilerepoFriendlyUnitsFrameNames,
	tilerepoPoiFrameNames,
	tilerepoSeasFrameNames,
} from "../config";
import { UpgradeIds } from "../config/upgrades";
import TileEntity from "../TileEntity";

type FishableAndSeaFrameNames =
	| FrameName.SHALLOW_SEA
	| FrameName.SHALLOW_SEA_SMALL_FISH
	| FrameName.SHALLOW_SEA_MEDIUM_FISH
	| FrameName.DEEP_SEA
	| FrameName.DEEP_SEA_MEDIUM_FISH
	| FrameName.DEEP_SEA_BIG_FISH;

class ShallowSeaTerrainTileEntity extends TileEntity {
	public static readonly frameName: FishableAndSeaFrameNames =
		FrameName.SHALLOW_SEA;

	public get canUpgradeTo(): Set<FrameName> {
		if (this.cachedCanUpgradeTo) return this.cachedCanUpgradeTo;

		const upgrades = new Set<FrameName>(super.canUpgradeTo);
		if (!this.upgrades.size) return (this.cachedCanUpgradeTo = upgrades);

		// Chceme lodicky ponukat aj ak nie je volna kapacita - budu locknute, ale budu tam, aby ich hrac videl.
		// const shipyard = this.tilerepo.getAShipyardEntity()!;
		// const availableFishingBoats = shipyard?.availableFishingBoats ?? 0;

		// if (availableFishingBoats <= 0) {
		// 	upgrades.delete(FrameName.SHALLOW_SEA_FISHING_BOAT);
		// 	upgrades.delete(FrameName.DEEP_SEA_FISHING_BOAT);
		// 	upgrades.delete(FrameName.SHALLOW_SEA_BIG_FISHING_BOAT);
		// 	upgrades.delete(FrameName.DEEP_SEA_FISHING_BOAT);
		// }

		if (this.frameName === FrameName.SHALLOW_SEA) {
			upgrades.delete(FrameName.DEEP_SEA_FISHING_BOAT);
			upgrades.delete(FrameName.DEEP_SEA_BIG_FISHING_BOAT);
		}

		if (this.frameName === FrameName.DEEP_SEA) {
			upgrades.delete(FrameName.SHALLOW_SEA_FISHING_BOAT);
			upgrades.delete(FrameName.SHALLOW_SEA_BIG_FISHING_BOAT);
		}

		if (this.frameName === FrameName.SHALLOW_SEA) {
			const neighbours = this.tilerepo
				.getNeighbourTileIndexesByTileCoordinates(
					{ x: this.x, y: this.y },
					0,
				)
				.map((tileIndex: TileIndex): TileNeighbour | null => {
					const [tileId] =
						this.tilerepo.getTileIdsByTileIndex(tileIndex);
					if (!tileId) return null;

					const frameName =
						this.tilerepo.getFrameNameByTileId(tileId);
					if (!frameName) return null;

					return {
						tileIndex,
						tileId,
						frameName,
					};
				})
				.filter(
					(neighbour: TileNeighbour | null): boolean =>
						neighbour !== null &&
						!tilerepoSeasFrameNames.has(neighbour.frameName) &&
						!tilerepoPoiFrameNames.has(neighbour.frameName),
				) as Array<TileNeighbour>;

			if (!neighbours.length) {
				upgrades.delete(FrameName.SHIPYARD);
				upgrades.delete(FrameName.BIG_SHIPYARD);
				upgrades.delete(FrameName.PORT);
				upgrades.delete(FrameName.FISHING_VILLAGE);
			}

			// if (
			// 	!neighbours.filter(({ frameName }: TileNeighbour): boolean =>
			// 		tilerepoSettlementEmptyFrameNames.has(frameName),
			// 	).length
			// ) {
			// 	upgrades.delete(FrameName.MILITARY_SHIPYARD);
			// }
		}

		const ssr = useSiegeSystemRepository();
		if (!ssr.isUnlocked || !this.isBlockedByEnemy) {
			for (const frameName of tilerepoFriendlyUnitsFrameNames) {
				upgrades.delete(frameName);
			}
		}

		return (this.cachedCanUpgradeTo = upgrades);
	}

	public get exploreCoefficient(): number | null {
		let exploreCoefficient = super.exploreCoefficient || 0;

		exploreCoefficient -= getUpgradeCurrentReplaceValueById(
			UpgradeIds.pirate_navigation,
		);
		return Math.max(exploreCoefficient, 0);
	}
}

export default ShallowSeaTerrainTileEntity;
